module.exports = __webpack_public_path__ + "fb89cba2b87b9d359eca40ae27ab6e2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_90.jpg
// module id = 1690
// module chunks = 5